export class InitializeHomeStateShifts {
  static readonly type = '[Home] InitializeHomeStateShifts';
  constructor() {}
}

export class GetWorktimeStats {
  static readonly type = '[Home] Get worktime summary stats';
}

export class GetOvertimeStats {
  static readonly type = '[Home] Get overtime time stats once a day';
  constructor(public userId: string) {}
}
